import { create } from 'zustand';

export const useSKClubStore = create((set) => ({
  firebaseUser: null,
  loading: true,
  skPerks: null,
  coinBalance: 0,
  setFirebaseUser: (firebaseUser) => set({ firebaseUser }),
  setLoading: (loading) => set({ loading }),
  setSkPerks: (skPerks) => set({ skPerks }),
  setCoinBalance: (coinBalance) => set({ coinBalance }),
  reset: () => set({ firebaseUser: null, loading: false, skPerks: null, coinBalance: 0 }),
}));
